
export default [

  {
    path: '/consultar_cartera_odontologia',
    name: 'consultar_cartera_odontologia',
    component: () => import('@/views/odontologia/CarteraOdontologia.vue'),
    meta: {
      pageTitle: 'Cartera Odontologia',
      breadcrumb: [
        
        {
          text: 'Odontologia',
          active: true,
        },
      ],
      requiresAuth: true,
      //requiredPermission: 'consultar_cartera_examen',
      accion1: { url: '/crear_item_odontologia' },
      pdf: true,
      excel: true
    },
  },
  {
    path: '/crear_item_odontologia',
    name: 'crear_item_odontologia',
    component: () => import('@/views/odontologia/EditarItemOdontologia.vue'),
    meta: {
      pageTitle: 'Crear Item Odontologia',
      breadcrumb: [
        {
          text: 'Cartera Odontologia',
          to: '/consultar_cartera_odontologia',
        },
        {
          text: 'Crear Item Odontologia',
          active: true,
        },
      ],
      requiresAuth: true,
      //requiredPermission: 'crear_procesoclinico',
    },
  },
]